export default class Vector2 
{
    public x: number = 0;
    public y: number = 0;

    public constructor(x: number, y: number)
    {
        this.x = x;
        this.y = y;
    }

    public Add(other : Vector2) : Vector2
    {
        return new Vector2(this.x + other.x, this.y + other.y);
    }

    public Minus(other : Vector2) : Vector2
    {
        return new Vector2(this.x - other.x, this.y - other.y);
    }

    public toString() : string
    {
        return "(" + this.x + ", " + this.y + ")";
    }
}